import React, { type ReactNode } from 'react';

interface State {
  hasError: boolean;
  error: Error | null;
}

export class ErrorBoundary extends React.Component<
  { children: ReactNode; fallback?: (error: Error, retry: () => void) => ReactNode },
  State
> {
  state: State = { hasError: false, error: null };

  static getDerivedStateFromError(error: Error): State {
    return { hasError: true, error };
  }

  componentDidCatch(error: Error, info: React.ErrorInfo): void {
    console.error('[ErrorBoundary]', error, info.componentStack);
  }

  render(): ReactNode {
    if (this.state.hasError && this.state.error) {
      const retry = () => this.setState({ hasError: false, error: null });
      if (this.props.fallback) {
        return this.props.fallback(this.state.error, retry);
      }
      return <p role="alert">Something went wrong. Please try again.</p>;
    }
    return this.props.children;
  }
}
